module.exports = __webpack_public_path__ + "img/economia_prata.45ea65b7.png";